import React, { useEffect } from "react";
import styled from "styled-components";
import { TicketStar } from "../../assets/icons";
import { ParksData } from "../../tempConst";
import { useLocation, useNavigate } from "react-router-dom";
import { Text } from "../../TextConstants";
import { Colors } from "../../ColorConstants";
import { trackFBEvent } from "../../analytics";
import ReactGA from "react-ga4";

const EntertainmentPark = ({ data }) => {
  const navigate = useNavigate();
  const handleBuyTicket = (item) => {
    trackFBEvent(item?.shortName, {});
    handleTestEvent(item?.name);
    if (item.shortName === "aqua_zone") {
      navigate(`/app/aqua`);
    } else {
      navigate(`/app/booking/${item._id}`);
    }
  };

  const handleTestEvent = (value) => {
    const isUAT =
      window.location.hostname.includes("uat") ||
      window.location.hostname.includes("localhost");
    const type = localStorage.getItem("type");
    if (!isUAT) {
      ReactGA.event({
        category: "Custom Events",
        action: `${value} clicked`,
        label: `${value} clicked by ${type}`,
      });
    }
  };

  return (
    <ParksDivContainer>
      <Container>
        {data.length > 0 &&
          data.map((item, index) => (
            <SubContainer key={index}>
              <MainDiv onClick={() => handleBuyTicket(item)}>
                <ParksDiv>
                  <ImageContainer>
                    <Image src={item.images[0].url} />
                    <GradientOverlay>
                      <GradientBlackOverlay>
                        <img src={item.logo} />
                      </GradientBlackOverlay>
                    </GradientOverlay>
                  </ImageContainer>
                </ParksDiv>
                <ButtonWrapper>
                  <TextDiv>
                    <Title>{item.name}</Title>
                    <TagLine>{item.description}</TagLine>
                  </TextDiv>
                </ButtonWrapper>
              </MainDiv>
            </SubContainer>
          ))}
      </Container>
    </ParksDivContainer>
  );
};

const Container = styled.div`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;

  justify-content: center;
  @media (max-width: 768px) {
    gap: 1rem 1rem;
  }
`;
const SubContainer = styled.div``;

const MainDiv = styled.div`
  // height: 15rem;
  width: 14rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  flex-direction: column;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-8px);
    cursor: pointer;
  }
  @media (max-width: 768px) {
    // height: 10rem;
    width: 10rem;
    // margin-top: 1rem;
    &:hover {
      transform: translateY(0px);
      cursor: pointer;
    }
  }
`;

const ParksDiv = styled.div`
  display: flex;
  height: auto;
  width: 100%;
  align-self: flex-start;
  position: relative;
  justify-content: center;
`;

const ParksDivContainer = styled.div`
  margin-top: 1.5rem;
  width: 70vw;
  @media (max-width: 1210px) {
    width: 100%;
    margin-top: 0.5rem;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 15.625rem;

  border-radius: 1rem 1rem 0 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  max-height: 100%;
  width: 15.625rem;
  height: 9.375rem;
  border-radius: 1rem 1rem 0 0;
  object-fit: fill;
  opacity: 0.5;
  @media (max-width: 768px) {
    height: 7rem;
  }
`;
const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff8c;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 6rem;
    height: 6rem;
  }
`;

const GradientBlackOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  // linear-gradient(
  //   to bottom,
  //   ${Colors.blackWithZeroOpacity},
  //   ${Colors.lightBlack4}
  // );
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 7rem;
    height: 7rem;
  }
`;

const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`;

const Title = styled.span`
  color: ${Colors.white};
  font-family: "Poppins";
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const TagLine = styled(Title)`
  text-align: center;
  font-size: 0.6rem;
  font-weight: 500;
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 768px) {
    font-size: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  border-radius: 0 0 1rem 1rem;
  border-style: none;
  background: ${Colors.aqua};
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.5rem;
  padding: 0 0.5rem;
  cursor: pointer;
  box-sizing: border-box;
`;

const ButtonTitle = styled.span`
  color: ${Colors.white};
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const ButtonImage = styled.img`
  background: url(${TicketStar});
  width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.3rem;
  @media (max-width: 768px) {
    width: 1rem;
    height: 1rem;
  }
`;
export default EntertainmentPark;
